const pageNameKey = "checkBoxTextWrapper";

export const checkBoxTextWrapperEn = {
  [pageNameKey]: {
    checkBoxText: "Verify the identity of the server using a certificate",
  },
};

export const checkBoxTextWrapperPtBr = {
  [pageNameKey]: {
    checkBoxText: "Verifique a identidade do servidor usando um certificado",
  },
};

export const checkBoxTextWrapperDe = {
  [pageNameKey]: {
    checkBoxText:
      "Überprüfen Sie die Identität des Servers mithilfe eines Zertifikats",
  },
};

export const checkBoxTextWrapperZhHans = {
  [pageNameKey]: {
    checkBoxText: "使用证书验证服务器的身份",
  },
};

export const checkBoxTextWrapperIt = {
  [pageNameKey]: {
    checkBoxText: "Verifica l'identità del server utilizzando un certificato",
  },
};

export const checkBoxTextWrapperEs = {
  [pageNameKey]: {
    checkBoxText: "Verifique la identidad del servidor mediante un certificado",
  },
};

export const checkBoxTextWrapperNl = {
  [pageNameKey]: {
    checkBoxText:
      "Controleer de identiteit van de server met behulp van een certificaat",
  },
};

export const checkBoxTextWrapperTr = {
  [pageNameKey]: {
    checkBoxText: "Sertifika kullanarak sunucunun kimliğini doğrulama",
  },
};
